import { FORM_BUILDER_FIELD_TYPE } from "@loanbossinc/component-library";

import { isSysAdmin } from "../loanDetailEditUtil";

import { shouldShowSignor } from "./section-loan-borrower-docs-row-logic";

export const rows = {
  title: {
    isTitle: true,
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "Borrower Docs",
        style: {
          marginLeft: "0",
          fontFamily: "Work Sans",
          fontStyle: "normal",
          fontWeight: "500",
          fontSize: "16px",
          lineHeight: "14px",
          textTransform: "uppercase",
          color: "#000000",
          marginBottom: "10px"
        }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.borrowerDocs"
      }
    ]
  },
  monthlySubSection: {
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "Monthly",
        style: {
          marginLeft: "0",
          fontFamily: "Work Sans",
          fontStyle: "normal",
          fontWeight: "bold",
          fontSize: "12px",
          textTransform: "uppercase",
          color: "#000000"
        }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.borrowerDocsMonthly"
      }
    ]
  },
  borrowerDocsMonthly: {
    isVisible: data => isSysAdmin(data),
    label: "Borrower Docs Monthly",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "covenants.borrowerDocsMonthly",
        variant: "filled",
        multiline: true
      }
    ]
  },
  calculationPeriodsMonthly: {
    label: "Delivery Period (Days)",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NUMBER,
        name: "covenants.borrowerDeliveryPeriodMonthly",
        variant: "filled"
      }
    ]
  },
  listOfDocsMonthly: {
    label: "List Of Docs",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.MULTI_SELECT,
        name: "covenants.borrowerListOfDocsMonthly",
        variant: "filled",
        displayWith: option => option && option.length > 0 && option.map(x => x.name),
        setValueWith: option => option && option.length > 0 && option.map(x => x.id),
        parentId: "borrowerDocsRows",
        onChange: (selectedItems, formik) => {
          const { covenants } = formik.values;
          let borrowerListOfDocsMonthly = [];
          if (selectedItems !== null && selectedItems.length > 0) {
            borrowerListOfDocsMonthly = selectedItems.map(x => ({ id: x, covenantId: covenants.id, configItemId: x, type: "borrowerListOfDocsMonthly" }));
          }
          covenants.borrowerListOfDocsMonthly = borrowerListOfDocsMonthly;
          formik.setValues({ ...formik.values, covenants });
        }
      }
    ]
  },
  reportingStartDateMonthly: {
    label: "Reporting Start Date",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: "covenants.borrowerDocsMonthlyReportingStart",
        variant: "filled"
      }
    ]
  },
  quarterlySubSection: {
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "Quarterly",
        style: {
          marginLeft: "0",
          fontFamily: "Work Sans",
          fontStyle: "normal",
          fontWeight: "bold",
          fontSize: "12px",
          textTransform: "uppercase",
          color: "#000000"
        }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.borrowerDocsQuarterly"
      }
    ]
  },
  borrowerDocsQuarterly: {
    isVisible: data => isSysAdmin(data),
    label: "Borrower Docs Quarterly",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "covenants.borrowerDocsQuarterly",
        variant: "filled",
        multiline: true
      }
    ]
  },
  calculationPeriodsQuarterly: {
    label: "Delivery Period (Days)",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NUMBER,
        name: "covenants.borrowerDeliveryPeriodQuarterly",
        variant: "filled"
      }
    ]
  },
  listOfDocsQuarterly: {
    label: "List Of Docs",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.MULTI_SELECT,
        name: "covenants.borrowerListOfDocsQuarterly",
        variant: "filled",
        displayWith: option => option && option.length > 0 && option.map(x => x.name),
        setValueWith: option => option && option.length > 0 && option.map(x => x.id),
        parentId: "borrowerDocsRows",
        onChange: (selectedItems, formik) => {
          const { covenants } = formik.values;
          let borrowerListOfDocsQuarterly = [];
          if (selectedItems !== null && selectedItems.length > 0) {
            borrowerListOfDocsQuarterly = selectedItems.map(x => ({ id: x, covenantId: covenants.id, configItemId: x, type: "borrowerListOfDocsQuarterly" }));
          }
          covenants.borrowerListOfDocsQuarterly = borrowerListOfDocsQuarterly;
          formik.setValues({ ...formik.values, covenants });
        }
      }
    ]
  },

  reportingStartDateQuarterly: {
    label: "Reporting Start Date",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: "covenants.borrowerDocsQuarterlyReportingStart",
        variant: "filled"
      }
    ]
  },
  semiAnnuallySubSection: {
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "Semi-Annually",
        style: {
          marginLeft: "0",
          fontFamily: "Work Sans",
          fontStyle: "normal",
          fontWeight: "bold",
          fontSize: "12px",
          textTransform: "uppercase",
          color: "#000000"
        }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.borrowerDocsSemiAnnually"
      }
    ]
  },
  borrowerDocsSemiAnnually: {
    isVisible: data => isSysAdmin(data),
    label: "Borrower Docs SemiAnnually",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "covenants.borrowerDocsSemiAnnually",
        variant: "filled",
        multiline: true
      }
    ]
  },
  calculationPeriodsSemiAnnually: {
    label: "Delivery Period (Days)",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NUMBER,
        name: "covenants.borrowerDeliveryPeriodSemiAnnually",
        variant: "filled"
      }
    ]
  },
  listOfDocsSemiAnnually: {
    label: "List Of Docs",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.MULTI_SELECT,
        name: "covenants.borrowerListOfDocsSemiAnnually",
        variant: "filled",
        displayWith: option => option && option.length > 0 && option.map(x => x.name),
        setValueWith: option => option && option.length > 0 && option.map(x => x.id),
        parentId: "borrowerDocsRows",
        onChange: (selectedItems, formik) => {
          const { covenants } = formik.values;
          let borrowerListOfDocsSemiAnnually = [];
          if (selectedItems !== null && selectedItems.length > 0) {
            borrowerListOfDocsSemiAnnually = selectedItems.map(x => ({
              id: x,
              covenantId: covenants.id,
              configItemId: x,
              type: "borrowerListOfDocsSemiAnnually"
            }));
          }
          covenants.borrowerListOfDocsSemiAnnually = borrowerListOfDocsSemiAnnually;
          formik.setValues({ ...formik.values, covenants });
        }
      }
    ]
  },

  reportingStartDateAnnuallySemi: {
    label: "Reporting Start Date",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: "covenants.borrowerDocsSemiAnnuallyReportingStart",
        variant: "filled"
      }
    ]
  },
  annuallySubSection: {
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "Annually",
        style: {
          marginLeft: "0",
          fontFamily: "Work Sans",
          fontStyle: "normal",
          fontWeight: "bold",
          fontSize: "12px",
          textTransform: "uppercase",
          color: "#000000"
        }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.borrowerDocsAnnually"
      }
    ]
  },
  borrowerDocsAnnually: {
    isVisible: data => isSysAdmin(data),
    label: "Borrower Docs Annually",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "covenants.borrowerDocsAnnually",
        variant: "filled",
        multiline: true
      }
    ]
  },
  calculationPeriodsAnnually: {
    label: "Delivery Period (Days)",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NUMBER,
        name: "covenants.borrowerDeliveryPeriodAnnually",
        variant: "filled"
      }
    ]
  },
  listOfDocsAnnually: {
    label: "List Of Docs",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.MULTI_SELECT,
        name: "covenants.borrowerListOfDocsAnnually",
        variant: "filled",
        displayWith: option => option && option.length > 0 && option.map(x => x.name),
        setValueWith: option => option && option.length > 0 && option.map(x => x.id),
        parentId: "borrowerDocsRows",
        onChange: (selectedItems, formik) => {
          const { covenants } = formik.values;
          let borrowerListOfDocsAnnually = [];
          if (selectedItems !== null && selectedItems.length > 0) {
            borrowerListOfDocsAnnually = selectedItems.map(x => ({ id: x, covenantId: covenants.id, configItemId: x, type: "borrowerListOfDocsAnnually" }));
          }
          covenants.borrowerListOfDocsAnnually = borrowerListOfDocsAnnually;
          formik.setValues({ ...formik.values, covenants });
        }
      }
    ]
  },
  reportingStartDateAnnually: {
    label: "Reporting Start Date",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: "covenants.borrowerDocsAnnuallyReportingStart",
        variant: "filled"
      }
    ]
  },
  generalSubSection: {
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "General",
        style: {
          marginLeft: "0",
          fontFamily: "Work Sans",
          fontStyle: "normal",
          fontWeight: "bold",
          fontSize: "12px",
          textTransform: "uppercase",
          color: "#000000"
        }
      }
    ]
  },
  borrowerOficerCertificate: {
    label: "Officer Certificate",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.SWITCH,
        name: "covenants.borrowerOfficerCertificate",
        variant: "filled",
        hideLabel: true,
        label: "An officer certificate is required."
      }
    ]
  },
  signor: {
    isVisible: data => shouldShowSignor(data),
    label: "Signor",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        name: "covenants.borrowerSignorId",
        variant: "filled",
        parentId: "contacts",
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onchange: value => {}
      }
    ]
  }
};
